import { render } from "./ui-pagination.vue?vue&type=template&id=0344fe5f&ts=true"
import script from "./ui-pagination.vue?vue&type=script&lang=ts"
export * from "./ui-pagination.vue?vue&type=script&lang=ts"

import "./ui-pagination.vue?vue&type=style&index=0&id=0344fe5f&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__